import { Component, ErrorInfo, ReactNode } from "react";

interface Props {
  children: ReactNode;
}
interface CustomErrorType extends Error {
  apiErrorMessage: string | undefined;
}
interface State {
  hasError: boolean;
  error: CustomErrorType;
  open: boolean;
}

class CustomError extends Error {
  apiErrorMessage: string | undefined;
  constructor(apiErrorMessage?: string) {
    super();
    this.apiErrorMessage = apiErrorMessage ?? undefined;
  }
}
class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
    error: new CustomError(),
    open: false,
  };

  public static getDerivedStateFromError(): State {
    // Update state so the next render will show the fallback UI.
    return { hasError: true, error: new CustomError(), open: true };
  }

  public componentDidCatch(error: CustomError, errorInfo: ErrorInfo) {
    console.log("Uncaught error:", errorInfo);
    this.setState((p) => ({ ...p, error: error, open: true }));
  }

  public render() {
    if (this.state.hasError) {
      return (
        <>
          {<h1>{`${this.state.error.apiErrorMessage ?? this.state.error}`}</h1>}
        </>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
